<template>
    <div v-if="selectedTopSeller?.length">
        <div class="flex lg:w-2/3 justify-between items-center">
            <div>
                <UiComponentTypography tag="h2" variant="h1" class-name="max-lg:text-center"
                    >پیشنهاد نرس‌لند</UiComponentTypography
                >
                <UiComponentTypography
                    tag="p"
                    variant="h4"
                    class-name="font-thin my-3 mx-12 lg:mx-8 max-lg:text-center"
                >
                    با
                    <UiBrandText class-name="font-normal" />
                    تجربه جدیدی از طعم قهوه
                </UiComponentTypography>
            </div>
        </div>
        <!-- <div class="lg:hidden" v-if="mostTopSeller">
            <div class="relative flex gap-2 bg-white border rounded-md border-amazon-500 shadow-94 mt-24">
                <NuxtLink :to="`/product/${mostTopSeller.slug}`" class="w-1/2 text-center p-4 block shrink-0">
                    <UiComponentTypography tag="h4"> {{ mostTopSeller.name }} </UiComponentTypography>
                    <UiComponentTypography class="mt-2">
                        {{ mostTopSeller.about }}
                    </UiComponentTypography>
                </NuxtLink>
                <NuxtLink :to="`/product/${mostTopSeller.slug}`" class="w-1/2 block mx-auto -translate-y-14 scale-150">
                    <NuxtImg
                        :src="Object.values(mostTopSeller.feature_image)[0]?.original_url"
                        width="500"
                        format="webp"
                        loading="lazy"
                        sizes="250px sm:300px lg:500px"
                        placeholder
                    />
                </NuxtLink>
            </div>
        </div> -->
        <ul class="grid grid-cols-2 lg:flex gap-4 lg:gap-8 lg:pt-52 -mt-4 lg:mt-12">
            <li
                v-for="(item, index) in selectedTopSeller"
                class="lg:bg-white lg:border lg:rounded-md border-amazon-500 lg:shadow-94 pt-8 max-lg:p-2 lg:w-1/5 lg:last:w-2/5 max-lg:min-w-[50%]"
            >
                <div class="relative">
                    <NuxtLink
                        :to="`/product/${item.slug}`"
                        class="w-3/4 max-lg:block max-lg:mx-auto max-lg:translate-y-12 lg:w-full lg:absolute lg:bottom-[calc(100%-1rem)] lg:left-1/2 lg:-translate-x-1/2"
                    >
                        <NuxtImg
                            :alt="item.name"
                            :src="Object.values(item?.feature_image)[0]?.original_url"
                            width="500"
                            format="webp"
                            quality="90"
                            sizes="250px sm:300px lg:500px"
                            loading="lazy"
                            placeholder
                        />
                    </NuxtLink>
                    <NuxtLink
                        :to="`/product/${item.slug}`"
                        class="text-center p-4 pt-12 lg:pt-16 max-lg:w-full max-lg:block max-lg:bg-white max-lg:border max-lg:rounded-md border-amazon-500 max-lg:shadow-94"
                    >
                        <UiComponentTypography tag="h4" class-name="text-base"> {{ item.name }} </UiComponentTypography>
                        <UiComponentTypography class="mt-2 max-lg:hidden">
                            {{ item.about }}
                        </UiComponentTypography>
                    </NuxtLink>
                </div>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
import type { IResponse } from "~/libs/types/api/pagination";
import type { IProduct } from "~/libs/types/api/product";

const {
    data: products,
    status
} = await useLazyAsyncData<IResponse<IProduct[]>>(
    `best-seller`,
    () => fetchLocal("/products/get/trends"),
    {
        getCachedData(cacheKey: string, nuxtApp: any) {
            return nuxtApp.payload.data[cacheKey] || nuxtApp.static.data[cacheKey];
        },
    }
);

const selectedTopSeller = computed(() => {
    return products.value?.data ? products.value.data.slice(0, 4) : [];
});

// const mostTopSeller = computed(() => {
//     return products.value?.data ? products.value.data[0] : undefined;
// });
</script>

<style></style>
